import { Expose, plainToClassFromExist, Type } from 'class-transformer';

import { SnStreamSourceList } from './stream-source-list';

export class SnLiveVideoUrls {
  @Expose()
  @Type(() => SnStreamSourceList)
  public main: SnStreamSourceList;

  @Expose()
  @Type(() => SnStreamSourceList)
  public sub: SnStreamSourceList;

  constructor(data: any = {}) {
    plainToClassFromExist(this, data, { strategy: 'excludeAll' });
  }
}
